import { apiV2 } from "../v2";
import {
  adminRunIdRequest,
  getAdminRunEventsRequest,
  getAdminRunEventsResponse,
  getAdminRunResponse,
  getAdminRunsRequest,
  getAdminRunsResponse,
  postAdminRunRequest,
  postAdminRunResponse,
} from "./runs.dto";

export const getAdminRunsApi = apiV2("GET", "/admin/runs").withRequest(getAdminRunsRequest).withResponse(getAdminRunsResponse);

export const postAdminRunApi = apiV2("POST", "/admin/runs").withRequest(postAdminRunRequest).withResponse(postAdminRunResponse);

export const getAdminRunApi = apiV2("GET", "/admin/runs/:id").withRequest(adminRunIdRequest).withResponse(getAdminRunResponse);

export const getAdminRunEventsApi = apiV2("GET", "/admin/runs/:id/events").withRequest(getAdminRunEventsRequest).withResponse(getAdminRunEventsResponse);

export const cancelAdminRunApi = apiV2("POST", "/admin/runs/:id/cancel").withRequest(adminRunIdRequest).withResponse(getAdminRunResponse);

export const retryAdminRunApi = apiV2("POST", "/admin/runs/:id/retry").withRequest(adminRunIdRequest).withResponse(getAdminRunResponse);
